import { useMemo } from 'react'
import { useFirestoreGeneral } from "../../firebase/useFirestore.js"

const EventResultsCounter = ({ eventId }) => {
  const results = useFirestoreGeneral('EventResults', 'EventID', eventId || '')

  const uniqueCount = useMemo(() => {
    if (!results) return 0
    const s = new Set(results.map(r => r.SessionID || 'unknown'))
    return s.size
    }, [results])

  return <>{uniqueCount}</>
}

export default EventResultsCounter
